
//Debug logs beim Kunden einschalten:
// Console:
// allow pasting
/*
sessionStorage.setItem("DEBUG_LOGS", "true");
location.reload();
*/
const debugLogs = sessionStorage.getItem("DEBUG_LOGS") === "true";

if (process.env.NODE_ENV === 'production' && !debugLogs){
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.error = () => {};
}


import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import { vfmPlugin } from 'vue-final-modal'
//import JsonCSV from 'vue-json-csv'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import i18n from './i18n'

import { createRouter, createWebHashHistory } from 'vue-router'
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import VTailwindModal from './components/VTailwindModal.vue'
import VCardPairModal from './components/VCardPairModal.vue'
import LoginPage from './components/Login.vue'
import StatusPage from './components/Status.vue'
import StatisticPage from './components/Statistic.vue'
import CardsPage from './components/Cards.vue'
import SystemPage from './components/System.vue'
import PublicMeshPage from './components/PublicMesh.vue'
import SystemSortPage from './components/SystemSort.vue'
import MainPage from './components/Main.vue'
import SettingPage from './components/Settings.vue'
import SetGeneralPage from './components/Set-General.vue'
import SetCountryPage from './components/Set-Country.vue'
import SetSolarPage from './components/Set-Solar.vue'
import SetPublicPage from './components/Set-Public.vue'
import SetEasycheckPage from './components/Set-easyCheck.vue'
import SetEasybalancePage from './components/Set-easyBalance.vue'
import SetMeshPage from './components/Set-Mesh.vue'
import SetOcppPage from './components/Set-Ocpp.vue'
import SetOcppDlmPage from './components/Set-OcppDlm.vue'
import SetModbusPage from './components/Set-Modbus.vue'
import SetServicePage from './components/Set-Service.vue'
import SetUpdatePage from './components/Set-Update.vue'
import SetBackupPage from './components/Set-Backup.vue'
import SetNetworkPage from './components/Set-Network.vue'
import SetPara14Page from './components/Set-Para14.vue'
// import LogPage from './components/Log.vue'
import EventLog from './components/EventLog.vue'

// Plugins aktivieren
dayjs.extend(utc)
dayjs.extend(timezone)

const app = createApp(App)

// global verfügbar machen
app.config.globalProperties.$dayjs = dayjs


const store = createStore({
    state() {
        return {
            User: '',
            Role: '',
            WbIp: '',
            WbName: '',
            WbLogName: '',
            WbLogHost: '',
            WbLogSerial: '',
            WbLogIp: '',
            WbLogId: 0,
            WbTyp: '',
            WbId: 0,
            WbRemoteSettings: true,
            WbLTE: false,
            WbPubAccess: false,
            Mesh: false,
            NewSW: false,
            FirstLoad: true,
            Timeout: 15 * 60 * 1000,
            SortListRfid: 'namedown',
            SortListDlm: 'namedown',
            WbOtiVersion: '',            
            WbOtiInfo: '',
            WbSwVersion: '',
            WbApiVersion: '',
            WbDbVersion: '',
            token: {},
            NavTab: 1,
            CardsTab: 'charge',
            CardsType: 'rfid',
            WbGroups:[],
            WbClients:[],
            wblist: [],
            wbinfo: [],
            wbstatus: [],
            wbstatistic: [],
            webinterfacebuild: '1.1',
        }
    },
    mutations: {
        setCardsTab (state, payload) {
          state.CardsTab = payload
        },
        setCardsType (state, payload) {
          state.CardsType = payload
        },
        setSortListRfid (state, payload) {
          state.SortListRfid = payload
        },
        setSortListDlm (state, payload) {
          state.SortListDlm = payload
        },
        setTimeout (state, payload) {
          state.Timeout = payload
        },
        setFirstLoad (state, payload) {
          state.FirstLoad = payload
        },
        setNewSW (state, payload) {
          state.NewSW = payload
        },
        setWbOtiInfo (state, payload) {
          state.WbOtiInfo = payload
        },
        setWbOtiVersion (state, payload) {
          state.WbOtiVersion = payload
        },
        setWbSwVersion (state, payload) {
          state.WbSwVersion = payload
        },
        setWbApiVersion (state, payload) {
          state.WbApiVersion = payload
        },
        setWbRemoteSettings (state, payload) {
          state.WbRemoteSettings = payload
        },
        setLTE (state, payload) {
          state.WbLTE = payload
        },
        setPubAccess (state, payload) {
          state.WbPubAccess = payload
        },
        setToken (state, payload) {
          state.token = payload
        },
        setNavTab (state, payload) {
          state.NavTab = payload
        },
        setUser (state, payload) {
          state.User = payload
        },
        setRole (state, payload) {
          state.Role = payload
        },
        setMesh (state, payload) {
          state.Mesh = payload
        },
        setWbName (state, payload) {
          state.WbName = payload
        },
        setWbLogName (state, payload) {
          state.WbLogName = payload
        },
        setWbLogHost (state, payload) {
          state.WbLogHost = payload
        },
        setWbLogIp (state, payload) {
          state.WbLogIp = payload
        },
        setWbLogSerial (state, payload) {
          state.WbLogSerial = payload
        },
        setWbLogId (state, payload) {
          state.WbLogId = payload
        },
        setWbTyp (state, payload) {
          state.WbTyp = payload
        },
        setWbId (state, payload) {
          state.WbId = payload
        },
        setWbIp (state, payload) {
          state.WbIp = payload
        },
        setWbGroups (state, payload) {
          state.WbGroups = payload
        },
        setWbClients (state, payload) {
          state.WbClients = payload
        },
      },
    plugins: [createPersistedState()]
})

const routes = [
    {path: "/", name: "login", component: LoginPage},
    {path: "/Mesh", name: "publicmesh", component: PublicMeshPage},
    {path: "/System", name: "system", component: SystemPage},
    {path: "/SystemSort", name: "systemsort", component: SystemSortPage},
    {path: "/Status", name: "status", component: StatusPage},
    {path: "/Statistic", name: "statistic", component: StatisticPage},
    {path: "/Cards", name: "cards", component: CardsPage},
    {path: "/Main", name: "main", component: MainPage},
    {path: "/Settings", name: "settings", component: SettingPage},
    {path: "/SetGeneral", name: "setgeneral", component: SetGeneralPage},
    {path: "/SetCountry", name: "setcountry", component: SetCountryPage},
    {path: "/SetSolar", name: "setsolar", component: SetSolarPage},
    {path: "/SetPublic", name: "setpublic", component: SetPublicPage},
    {path: "/SetEasycheck", name: "seteasycheck", component: SetEasycheckPage},
    {path: "/SetEasybalance", name: "seteasybalance", component: SetEasybalancePage},
    {path: "/SetMesh", name: "setmesh", component: SetMeshPage},
    {path: "/SetOcpp", name: "setocpp", component: SetOcppPage},
    {path: "/SetOcppDlm", name: "setocppdlm", component: SetOcppDlmPage},
    {path: "/SetModbus", name: "setmodbus", component: SetModbusPage},
    {path: "/SetService", name: "setservice", component: SetServicePage},
    {path: "/SetUpdate", name: "setupdate", component: SetUpdatePage},
    {path: "/SetBackup", name: "setbackup", component: SetBackupPage},
    {path: "/SetNetwork", name: "setnetwork", component: SetNetworkPage},
    {path: "/SetPara14", name: "setpara14", component: SetPara14Page},
    // {path: "/Log", name: "logging", component: LogPage},
    {path: "/EventLog", name: "eventLog", component: EventLog}
]

const router = createRouter({
    history: createWebHashHistory(),
    routes: routes,
    linkActiveClass: "active"
})
app.config.globalProperties.$dayjs = dayjs
app.component("VTailwindModal", VTailwindModal)
app.component("VCardPairModal", VCardPairModal)
//app.component('downloadCsv', JsonCSV)
app.component('loading-overlay', Loading)
app.use(Donut)
app.use(VueAxios, axios)
app.use(vfmPlugin)
app.use(store)
app.use(router)
app.use(i18n)
app.mount('#app')